import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { makeAsyncScriptLoader } from '../../../utils/load-script-async';
import { hideLoaderInPopup } from '../../ui/popup';

const OPENTOK_JS_SRC = 'https://static.opentok.com/v2/js/opentok.min.js';
const OPENTOK_TEST_JS_SRC =
  'https://cdn.jsdelivr.net/npm/opentok-network-test-js@2.4.0/dist/NetworkTest/index.js';

export const asyncOpentokLoader = makeAsyncScriptLoader(
  [OPENTOK_JS_SRC, OPENTOK_TEST_JS_SRC],
  'ot_lib',
);

export function useOTScriptLoad(opened) {
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();

  const loadScript = () => {
    if (loaded) {
      dispatch(hideLoaderInPopup());
      return;
    }

    asyncOpentokLoader(() => {
      dispatch(hideLoaderInPopup());
      setLoaded(true);
    });
  };

  useEffect(() => {
    if (opened) {
      loadScript();
    }
  }, [opened]);

  return {
    loaded,
    loadScript,
  };
}



// WEBPACK FOOTER //
// ./src/redux/opentok/hooks/useOTScriptLoad.js